import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router'; 
import { SharedModule } from '../../shared/shared.module';
import { LocataireComponent } from './locataire/locataire.component';
import { ProprietaireComponent } from './proprietaire/proprietaire.component';
import { NgxStarRatingModule } from "ngx-star-rating";
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxPaginationModule } from 'ngx-pagination';
import { RouteLocataireGuard } from 'src/app/services/guards/routeLocataireGuard.guard';
import { RouteProprietaireGuard } from 'src/app/services/guards/routeProprietaireGuard.guard';

export const routes: Routes = [ 
  { path: '', redirectTo: 'list', pathMatch: 'full'},
  { path: 'locataire', canActivate: [RouteLocataireGuard],component: LocataireComponent, data: { breadcrumb: 'Mes Locations' }},
  { path: 'proprietaire', canActivate: [RouteProprietaireGuard],component: ProprietaireComponent, data: { breadcrumb: 'Mes Locations' }},
 
];

@NgModule({
  declarations: [
    LocataireComponent,
    ProprietaireComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    SharedModule,
    NgxStarRatingModule,
    NgxSpinnerModule,
    NgxPaginationModule,
  ],
})
export class MesLocationsModule {}
